import orderApi from '@/api/apiList/orderApi'
import siteConfiguration from '@/api/apiList/siteConfiguration'
const orderDetail = {
  state: {
    detail: {
         order_detail: [],
        order_detail_discard: [],
    },
  },
  getters: {


  },
  mutations: {
    
    getDetail(state, data) {
      state.detail = data
    }
  },
  actions: {
    


  },
};

export default orderDetail;